import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as THREE from 'three';
import './App.css';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
//import { DRACOs } from './draco/gltf/';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
//import gltfPath from './vaza/vaza.gltf';
import gltfPath from './vaza_nagy/vaza_nagy.gltf';
//import gltfPath from './kapolna0/kapolna0.gltf';
//import gltfPath from './kapolna1/kapolna1.gltf';

class App extends Component {
  componentDidMount() {
    // === THREE.JS CODE START ===
    //https://p3d.in/UILRk
    //https://google.github.io/draco/
    //https://codeworkshop.dev/blog/2020-11-05-displacement-maps-normal-maps-and-textures-in-react-three-fiber/?fbclid=IwAR0muPECXXXlo0HYBTgat06J6Z0cn-hP7p-gqerD7yFsH2PKu5lLUIEreYA
    var scene = new THREE.Scene();

    //https://github.com/facebookincubator/FBX2glTF

    // renderer
    var renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.outputEncoding = THREE.sRGBEncoding;
    this.mount.appendChild(renderer.domElement);

    // enviornment and bg

    //hdr: https://codesandbox.io/s/r3f-ibl-envmap-simple-dynamic-model-loading-wz7mp?file=/src/App.js

    const environment = new RoomEnvironment();
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    scene.background = new THREE.Color(0xf0f0f0);
    scene.environment = pmremGenerator.fromScene(environment).texture;

    // light
    const light = new THREE.HemisphereLight(0xffffbb, 0x080820, 0.01);
    scene.add(light);

    // camera
    //var camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
    const camera = new THREE.PerspectiveCamera(25, window.innerWidth / window.innerHeight, 0.1, 100);
    camera.position.set(1, 1, 0);

    // controls
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.update();

    // geom - simple cube
    var geometry = new THREE.BoxGeometry(1, 1, 1);
    var material = new THREE.MeshStandardMaterial({ color: 0x00ff00 });
    var cube = new THREE.Mesh(geometry, material);
    //scene.add(cube);

    // Instantiate a loader
    const loadingManager = new THREE.LoadingManager(() => {
      const loadingScreen = document.getElementById('loading-screen');
      loadingScreen.classList.add('fade-out');

      // optional: remove loader from DOM via event listener
      loadingScreen.addEventListener('transitionend', onTransitionEnd);
    });
    const loader = new GLTFLoader(loadingManager);
    const dracoLoader = new DRACOLoader();
    //dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/'); //copypasted draco/gltf/all files in public folder
    // dracoLoader.setDecoderPath('../node_modules/three/examples/js/libs/draco/'); //copypasted draco/gltf/all files in public folder

    // dracoLoader.setDecoderPath('https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/');

    // dracoLoader.setDecoderConfig({ type: 'js' }); // (Optional) Override detection of WASM support

    loader.setDRACOLoader(dracoLoader);
    //loader.setDRACOLoader(dracoLoader);
    // https://github.com/google/draco/tree/master/javascript/npm/draco3dgltf
    // dracoLoader.setDecoderPath('three/examples/jsm/loaders/DRACOLoader.js');
    //dracoLoader.setDecoderPath('three/examples/jsm/DRACOLasdsoader.js');

    loader.load(
      './kapolna0/kapolna0.gltf',
      function (gltf) {
        const model = gltf.scene;
        model.position.set(0, -0.2, 0);
        model.scale.set(0.025, 0.025, 0.025);
        scene.add(model);
        animate();
      },
      // called while loading is progressing
      function (xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
      },
      // called when loading has errors
      function (error) {
        console.log('An error happened');
      }
    );
    function onTransitionEnd(event) {
      event.target.remove();
    }
    // animation
    var animate = function () {
      requestAnimationFrame(animate);
      // required if controls.enableDamping or controls.autoRotate are set to true
      //controls.update();
      render();
    };
    window.addEventListener('resize', onWindowResize, false);
    function render() {
      //const delta = clock.getDelta();

      renderer.render(scene, camera);
    }
    function onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);
    }
    renderer.render(scene, camera);
  }

  render() {
    return <div ref={(ref) => (this.mount = ref)} />;
  }
}
export default App;
